import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
 title: 'title'               the name show in submenu and breadcrumb (recommend set)
 icon: 'svg-name'             the icon show in the sidebar,
 }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},

  // ,
  //
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '排名', icon: 'dashboard'},
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/welcome'),
        meta: {title: '欢迎页面', icon: 'document'}
      },
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/home',
    component: Layout,
    redirect: '/home',
    meta: {title: '排名', icon: 'dashboard'},
    children: [
      {
        path: 'rank',
        name: 'rank',
        component: () => import('@/views/home/index'),
        meta: {title: '排名', icon: 'dashboard'}
      },
    ]
  },
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '设备管理', icon: 'table'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '设备列表', icon: 'product-list'}
    },
      {
        path: 'deviceDiagnostics',
        name: 'deviceDiagnostics',
        component: () => import('@/views/pms/product/deviceDiagnostics'),
        meta: {title: '设备诊断', icon: 'form'}
      },
      {
        path: 'qrApk',
        name: 'qrApkManage',
        component: () => import('@/views/pms/product/qrApk'),
        meta: {title: 'APK 管理', icon: 'apk'}
      },
      {
        path: 'qrOtherApk',
        name: 'qrOtherApkManage',
        component: () => import('@/views/pms/product/qrOtherApk'),
        meta: {title: '其他 APK 管理', icon: 'otherApk'}
      },
      {
        path: 'deviceList',
        name: 'deviceList',
        component: () => import('@/views/pms/product/deviceList'),
        meta: {title: '充电设备号码生成库', icon: 'product-list'}
      },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加设备', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'addBatchProduct',
        name: 'addBatchProduct',
        component: () => import('@/views/pms/product/addBatch'),
        meta: {title: '添加批量设备', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改设备', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '代理商管理', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加代理商'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改代理商'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '项目管理', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },
      {
        path: 'agentList',
        name: 'agentList',
        component: () => import('@/views/pms/productAttr/agentList'),
        meta: {title: '分配代理商'},
        hidden: true
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden: true
      },
      {
        path: 'package',
        name: 'package',
        component: () => import('@/views/oms/package/index'),
        meta: {title: '套餐管理', icon: 'product-list'}
      },
      {
        path: 'addPackage',
        name: 'addPackage',
        component: () => import('@/views/oms/package/add'),
        meta: {title: '添加管理', icon: 'product-list'},
        hidden: true
      },
      {
        path: 'updatePackage',
        name: 'updatePackage',
        component: () => import('@/views/oms/package/update'),
        meta: {title: '更新管理', icon: 'product-list'},
        hidden: true
      },
      {
        path: 'adultPackage',
        name: 'adultPackage',
        component: () => import('@/views/oms/adultPackage/index'),
        meta: {title: '成人套餐', icon: 'product-list'}
      },
      {
        path: 'addAdultPackage',
        name: 'addAdultPackage',
        component: () => import('@/views/oms/adultPackage/add'),
        meta: {title: '添加成人套餐', icon: 'product-list'},
        hidden: true
      },
      {
        path: 'updateAdultPackage',
        name: 'updateAdultPackage',
        component: () => import('@/views/oms/adultPackage/update'),
        meta: {title: '更新成人套餐', icon: 'product-list'},
        hidden: true
      },
      {
        path: 'hotline',
        name: 'hotline',
        component: () => import('@/views/oms/hotline/index'),
        meta: {title: '服务热线', icon: 'product-list'}
      },
      {
        path: 'addHotline',
        name: 'addHotline',
        component: () => import('@/views/oms/hotline/add'),
        meta: {title: '添加管理', icon: 'product-list'},
        hidden: true
      },
      {
        path: 'updateHotline',
        name: 'updateHotline',
        component: () => import('@/views/oms/hotline/update'),
        meta: {title: '更新管理', icon: 'product-list'},
        hidden: true
      },
      {
        path: 'cooperation',
        name: 'cooperation',
        component: () => import('@/views/oms/cooperation/index'),
        meta: {title: '商务合作', icon: 'product-list'}
      },
      {
        path: 'waimai',
        name: 'waimai',
        component: () => import('@/views/oms/waimai/index'),
        meta: {title: '外卖推广', icon: 'product-list'}
      },
      {
        path: 'addWaimai',
        name: 'addWaimai',
        component: () => import('@/views/oms/waimai/add'),
        meta: {title: '添加管理', icon: 'product-list'},
        hidden: true
      },
      {
        path: 'updateWaimai',
        name: 'updateWaimai',
        component: () => import('@/views/oms/waimai/update'),
        meta: {title: '更新管理', icon: 'product-list'},
        hidden: true
      },{
        path: 'inner',
        name: 'inner',
        component: () => import('@/views/oms/inner/index'),
        meta: {title: '内部小程序审核', icon: 'form'}
      },
    ]
  },
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/advertise',
    name: 'sms',
    meta: {title: '广告', icon: 'sms'},
    children: [
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
      {
        path: 'advertiseCollect',
        name: 'advertiseCollect',
        component: () => import('@/views/sms/advertise/collect'),
        meta: {title: '激励广告统计', icon: 'sms-hot'}
      },
      {
        path: 'promotionStat',
        name: 'promotionStat',
        component: () => import('@/views/sms/promotionStat/index'),
        meta: {title: '推广统计', icon: 'sms-flash'}
      },
      {
        path: 'pendingCompany',
        name: 'pendingCompany',
        component: () => import('@/views/sms/pendingCompany/index'),
        meta: {title: '待推广公司', icon: 'sms-new'}
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '添加广告'},
        hidden: true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告'},
        hidden: true
      }
    ]
  },
  {
    path: '/bms',
    component: Layout,
    redirect: '/bms/bill',
    name: 'bms',
    meta: {title: '帐单管理', icon: 'total-yesterday'},
    children: [
      {
        path: 'bill',
        name: 'bill',
        component: () => import('@/views/bms/bill/index'),
        meta: {title: '帐单列表', icon: 'total-today'}
      },
      {
        path: 'withdraw',
        name: 'withdraw',
        component: () => import('@/views/bms/withdraw/index'),
        meta: {title: '提现管理', icon: 'total-week'}
      },
      {
        path: 'agentBalance',
        name: 'agentBalance',
        component: () => import('@/views/bms/agentBalance/index'),
        meta: {title: '代理商余额', icon: 'total-week'}
      },
      {
        path: 'addWithdraw',
        name: 'addWithdraw',
        component: () => import('@/views/bms/withdraw/add'),
        meta: {title: '添加'},
        hidden: true
      },
      {
        path: 'addWithdrawDetail',
        name: 'addWithdrawDetail',
        component: () => import('@/views/bms/withdraw/agentWithdrawDetail'),
        meta: {title: '提现详情'},
        hidden: true
      },
      {
        path: 'catfishConfig',
        name: 'catfishConfig',
        component: () => import('@/views/bms/catfishConfig/index'),
        meta: {title: '鲶鱼配置', icon: 'tree'}
      },
      {
        path: 'displayConfig',
        name: 'displayConfig',
        component: () => import('@/views/bms/displayConfig/index'),
        meta: {title: '大屏金额配置', icon: 'total-today'}
      },
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'announcement',
        name: 'announcement',
        component: () => import('@/views/ums/announcement/index'),
        meta: {title: '公告管理', icon: 'eye'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {
    path: '/app',
    component: Layout,
    redirect: '/app/dataAnalysis',
    meta: {title: 'app', icon: 'order'},
    children: [
      {
        path: 'dataAnalysis',
        name: 'dataAnalysis',
        component: () => import('@/views/app/dataAnalysis'),
        meta: {title: 'app数据分析', icon: 'eye'}
      }, {
        path: 'monitorDashboard',
        name: 'monitorDashboard',
        component: () => import('@/views/app/monitorDashboard'),
        meta: {title: '设备实时监控', icon: 'video'}
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js